<span *ngIf="podcastBlock_item">
  <a [routerLink]="['/retalk',podcastBlock_item.id]">
    <div class="col-lg-12 retalk-blq-inner-img">
                  <img [src]="img" class="img-full-cover" alt="{{podcastBlock_item.imgAlt}}">
                
                  <div class="prensa-showcase__footer size_showcase">
                    <!-- <div class="retalk-blq-inner-tit col-lg-12"> -->
                      <div class="text col-9 ps-2">
                          <p class="fw-bold tit_retalk" [innerHTML]="podcastBlock_item.titleSala"></p>
                      </div>

                     <div class="forma col-3">
                          <div class="forma-blq"></div>
                     </div>
                    <!-- </div> -->
                </div>
    </div>
  </a>
</span>
